
export interface AppLanguageOption {
  code: string;
  shortLabel: string;
  flag: string;
  translationKey: string;
}

export const APP_LANGUAGE_OPTIONS: readonly AppLanguageOption[] = [
  { code: 'ru-RU', shortLabel: 'RU', flag: '🇷🇺', translationKey: 'ru' },
  { code: 'be-BY', shortLabel: 'BY', flag: '🇧🇾', translationKey: 'be' },
  { code: 'kk-KZ', shortLabel: 'KZ', flag: '🇰🇿', translationKey: 'kk' },
  { code: 'en-EN', shortLabel: 'EN', flag: '🇬🇧', translationKey: 'en' },
  { code: 'es-ES', shortLabel: 'ES', flag: '🇪🇸', translationKey: 'es' },
  { code: 'de-DE', shortLabel: 'DE', flag: '🇩🇪', translationKey: 'de' },
  { code: 'fr-FR', shortLabel: 'FR', flag: '🇫🇷', translationKey: 'fr' },
  { code: 'pl-PL', shortLabel: 'PL', flag: '🇵🇱', translationKey: 'pl' },
] as const;

export const getLanguageOption = (language: string): AppLanguageOption =>
  APP_LANGUAGE_OPTIONS.find((option) => option.code === language) || APP_LANGUAGE_OPTIONS[0];

export const getFlagForLanguage = (language: string): string => getLanguageOption(language).flag;

export const getLanguageBadgeForLanguage = (language: string): string => {
  const option = getLanguageOption(language);
  return option.shortLabel;
};
